import axios from 'axios';
import i18n from 'i18next';
import { LOCAL_STORAGE_KEYS } from '@/utils/constants';

const bearer = (token: string | null) => `Bearer ${token}`;

const storage = window.localStorage;

export const infermedicaClient = axios.create({
  baseURL: `${import.meta.env.VITE_API_URL || ''}/v2/infermedica/delegate`,
});

infermedicaClient.interceptors.request.use(
  (config) => {
    config.headers.Authorization = bearer(
      storage.getItem(LOCAL_STORAGE_KEYS.ACCESS_TOKEN),
    );

    const token = storage.getItem(LOCAL_STORAGE_KEYS.INFERMEDICA_TOKEN);
    const refreshToken = storage.getItem(
      LOCAL_STORAGE_KEYS.INFERMEDICA_REFRESH_TOKEN,
    );

    config.headers['X-Infermedica-Authorization'] = bearer(token);
    config.headers['X-Infermedica-Refresh'] = refreshToken;
    config.headers['X-User-Language'] = i18n.language;

    return config;
  },
  (error) => {
    return Promise.reject(new Error(error));
  },
);

infermedicaClient.interceptors.response.use(
  (config) => config,
  async (error) => {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Make refresh token request directly to avoid circular dependency
        const {
          data: { token },
        } = await infermedicaClient.post<{ token: string }>(
          '/auth/refresh_token',
          {},
        );

        storage.setItem(LOCAL_STORAGE_KEYS.INFERMEDICA_TOKEN, token);

        return infermedicaClient(originalRequest);
      } catch (refreshError) {
        storage.removeItem(LOCAL_STORAGE_KEYS.INFERMEDICA_TOKEN);

        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  },
);
